import { createSlice } from "@reduxjs/toolkit";

export const setReducer = createSlice({
  name: "setFileNumber",
  initialState: {
    value: null,
  },
  reducers: {
    setFileNumber: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setFileNumber } = setReducer.actions;

export default setReducer.reducer;
